import React, { useEffect, useState } from "react";
import { NXCalenderStar } from "../../icons";
import NXDateRangePicker from "./NXDateRangePicker";
import formatDateRangeLabel from "./utils";

// Define the type for the date range
interface DateRange {
  startDate: Date | null;
  endDate: Date | null;
  key: string;
}


interface DateRangePickerButtonProps {
  onChange?: (ranges: DateRange) => void;
  onApply: (ranges: DateRange) => void;
  initialLabel?: string;
  size?: 'sm' | 'md' | 'lg';
  defaultValue?: any;
}

const DateRangePickesrButton: React.FC<DateRangePickerButtonProps> = ({ onChange, onApply, initialLabel = "Select Date Range", size = 'md', defaultValue }) => {
  const [isDateRangePickerOpen, setIsDateRangePickerOpen] = useState(false);
  const [label, setLabel] = useState(initialLabel);
  const [dateRange, setDateRange] = useState<DateRange | null>(defaultValue || null);

  // Function to open the Date Range Picker modal
  const openDateRangePicker = () => {
    setIsDateRangePickerOpen(true);
  };

  const closeDateRangePicker = () => {
    setIsDateRangePickerOpen(false);
  };

  const handleDateRangeSelect = (ranges: DateRange) => {
    setDateRange(ranges);
    onChange?.(ranges);
  };


  

  const onApplyHandle = () => {
    const newLabel = formatDateRangeLabel(dateRange?.startDate, dateRange?.endDate);
    setLabel(newLabel);
    onApply(dateRange!); // Use the dateRange object as the argument
  };

  useEffect(() =>  {
    if (defaultValue) {
      const newLabel = formatDateRangeLabel(defaultValue.startDate, defaultValue.endDate);
      setLabel(newLabel);
    }
  }, []);

  const sizeClasses = size === 'sm' ? 'px-2 py-2 text-sm' : size === 'lg' ? 'px-6 py-4 text-lg' : 'px-4 py-3';


  return (
    <>
      <button
        className={`flex items-center gap-3 bg-secondary-50 rounded-md text-base-300 ${sizeClasses}`}
        onClick={openDateRangePicker}
      >
        <NXCalenderStar />
        <span className="hidden ml:block md:text-sm lg:text-base text-nowrap">{label}</span>
      </button>

      {/* Date Range Picker Modal */}
      <NXDateRangePicker
        isOpen={isDateRangePickerOpen}
        onClose={closeDateRangePicker}
        onDateRangeSelect={handleDateRangeSelect}
        onApply={onApplyHandle}
        defaultValue={defaultValue}
      />
    </>
  );
};

export default DateRangePickesrButton;
